<template>
  <div class="page__wrapper">
    <div class="app__name">RepFinder</div>
    <button @click="triggerAuth">Login With Google</button>
  </div>
</template>

<script>
import {store} from '@/store'
import router from '@/router'
import * as firebase from 'firebase/app'
export default {
  name: "GoogleAuth",
  computed: {
    user: function(){
      return store.state.user
    } 
  },
  methods: {
    triggerAuth: function(){
      var provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithPopup(provider).then(function(result) {
      var token = result.credential.accessToken;
      var user = result.user;

      var userdata = {}
      userdata.photo = user.photoURL
      userdata.token = token
      userdata.email = user.email
      userdata.name = user.displayName
      userdata.refreshToken = user.refreshToken
      if(user.email.includes('@bargreen.com')){
        localStorage.setItem('repuser', JSON.stringify(userdata))
        store.commit('setuser', userdata)
      } else {
        alert('Please use your @bargreen.com email address to login.')
        store.dispatch('signOut')
      }
    }).catch(function(error) {
      console.log(error)
    });
    }
  },
  watch: {
    user: function(val){
      if(val.email) {
        router.push({path: '/'})
      }
    }
  }
}
</script>

<style scoped lang="less">
.shadow {
  box-shadow: 0px 2px 12px 0px rgba(0,0,0,0.25);
}
.page__wrapper {
  padding: 24px;
  background-color: #1882e6;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
}

.app__name {
  font-size: 1.75em;
  font-weight: bold;
  margin-bottom: 24px;
}

button {
  background-color: white;
  padding: 12px 24px;
  border: none;
  font-size: 1em;
  font-weight: bold;
  border-radius: 3px;
  cursor: pointer;
  &:extend(.shadow);
}
</style>



// WEBPACK FOOTER //
// src/components/auth/GoogleAuth.vue